import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const PublicBreadcrumbs = ({ items }) => {
  if (!items?.length) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-stone-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={`${item.name}-${item.path}`} className="flex items-center gap-2">
              {index > 0 && <ChevronRight className="h-4 w-4 text-stone-400" />}
              {isLast ? (
                <span aria-current="page" className="font-medium text-stone-800">
                  {item.name}
                </span>
              ) : (
                <Link to={item.path} className="hover:text-emerald-700">
                  {item.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default PublicBreadcrumbs;
